var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',{staticClass:"page-main"},[_c('banner'),_c('card'),_c('service'),_c('season'),_c('report',{attrs:{"prev-route":_vm.prevRoute}}),_c('fonts')],1)}
var staticRenderFns = []

export { render, staticRenderFns }